var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-container',[_c('v-row',[_c('v-col',[_c('v-card',{staticClass:"mx-auto",attrs:{"max-width":"600","tile":""}},[_c('p',[_vm._v("Welcome Mobile")])])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }